
































// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

@Component({
  name: 'InvitesFormComponent',
  components: { 
    VuePhoneNumberInput: () => import('vue-phone-number-input')
   }
})
export default class InvitesFormComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: 'Cancel' })
  public cancelBtnText: string

  @Prop({ default: 'Invite' })
  public okBtnText: string

  @Prop({ default: true })
  public alertOrToastWhenDone: boolean

  @Prop({ default: false })
  public alsoInviteStoryTeller: boolean

  @Prop({ default: 5 })
  public startingNumberOfInviteSlots: number

  @Prop({ default: true })
  public autoAddSlots: boolean

  // public reactive member variables available to the html template
  public numSlots: number = this.startingNumberOfInviteSlots
  public firstNames: string[] = null
  public lastNames: string[] = null;
  public emails: string[] = null;
  public invitedByName: string = null
  public storyTellerFirstName: string = null
  public storyTellerLastName: string = null
  public storyTellerEmail: string = null
  public phone: string = null;
  public fullPhoneNumber: string = null;
  public phoneNumberIsValid: boolean = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public listenerEmailPlaceHolder(slot: number) { return this.firstNames[slot] ? this.firstNames[slot] + "'s email address" : "Email address"}
  public storyTellerEmailPlaceHolder() { return this.storyTellerFirstName ? this.storyTellerFirstName + "'s email address" : "Email address"}

  public listenerSectionTitle(): string { return this.storyTellerFirstName ? this.storyTellerFirstName + "'s listening circle" : "Listening circle" }

  public onPhoneUpdate(o: any) {
    this.fullPhoneNumber = o.e164
    this.phoneNumberIsValid = o.isValid
  }

  public clearFields() {
    this.storyTellerFirstName = null
    this.storyTellerLastName = null
    this.storyTellerEmail = null
    this.phone = null;
    this.firstNames = []; for (let x = 0; x < this.numSlots; x++) this.firstNames.push(null)
    this.lastNames = []; for (let x = 0; x < this.numSlots; x++) this.lastNames.push(null)
    this.emails = []; for (let x = 0; x < this.numSlots; x++) this.emails.push(null)
  }
  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: { invitedByName: string }) {
    if (!dynamicProps) return
    this.invitedByName = dynamicProps.invitedByName
  }

  // Cool UX to reinforce to use that emails are case-insensitive and to make more rows if necessary
  public onChangeST(type: string) {
    if (type === 'em') this.storyTellerEmail = this.storyTellerEmail.toLocaleLowerCase()
  }
  public onChange(type: string, n: number) {
    if (type === 'em') Vue.set(this.emails, n - 1, this.emails[n - 1].toLocaleLowerCase())
    if (this.autoAddSlots && n === this.numSlots) this.numSlots++
  }

  // Cool UX to make enter key change focus to next input
  public onEnter(type: string, n: number) {
    let nextRef: string
    let nextN: number = n
    if (type === 'fn') nextRef = 'ln'
    if (type === 'ln') nextRef = 'em'
    if (type === 'em') { nextRef = 'fn'; nextN = n + 1 }
    // console.log(nextRef);
    // console.dir(this.$refs);
    (this.$refs[nextRef][nextN - 1] as any).$el.focus()
  }

  public async onOK() {
    // tidy up form fields
    this.storyTellerFirstName = this.storyTellerFirstName ? utils.capitalizeFirstLetter(this.storyTellerFirstName.trim()) : null
    this.storyTellerLastName = this.storyTellerLastName ? utils.capitalizeFirstLetter(this.storyTellerLastName.trim()) : null
    this.storyTellerEmail = this.storyTellerEmail ? this.storyTellerEmail.trim() : null
    this.firstNames = this.firstNames.map((s) => s ? utils.capitalizeFirstLetter(s.trim()) : s)
    this.lastNames = this.lastNames.map((s) => s ? utils.capitalizeFirstLetter(s.trim()) : s)
    this.emails = this.emails.map((s) => s ? s.trim() : s)

    // validate form fields
    let abort: boolean = false

    if (this.alsoInviteStoryTeller) {
      if (!this.storyTellerFirstName || this.storyTellerFirstName.length === 0 || !this.storyTellerLastName || this.storyTellerLastName.length === 0) {
        utils.toast(this, 'Missing fields', `Please enter both a first and last name for the storyteller`)
        abort = true
      }
      if (!this.storyTellerEmail || this.storyTellerEmail.length === 0 || !utils.isValidEmail(this.storyTellerEmail)) {
        utils.toast(this, 'Missing fields', `Please enter an email address for the storyteller`)
        abort = true
      }
      if (!this.fullPhoneNumber) {
        utils.toast(this, 'Missing fields', `Please enter a phone # for the storyteller`)
        abort = true
      } else if (!this.phoneNumberIsValid) {
        utils.toast(this, 'Invalid phone #', `Please enter a valid phone # for the storyteller`)
        abort = true
      }
    }

    let numFilled: number = 0
    for (let x = 0; x < this.numSlots; x++) {
      if ((this.firstNames[x] && this.firstNames.length > 0) ||
          (this.lastNames[x] && this.lastNames.length > 0) ||
          (this.emails[x] && this.emails.length > 0)) {
            numFilled++
          }
    }
    for (let x = 0; x < numFilled; x++) {
      if (!this.firstNames[x] || this.firstNames[x].length === 0 || !this.lastNames[x] || this.lastNames[x].length === 0) {
        utils.toast(this, 'Missing fields', `Please enter both a first and last name for friend ${x + 1}`)
        abort = true
      }
      if (!this.emails[x] || this.emails[x].length === 0) {
        utils.toast(this, 'Missing fields', `Please enter an email address for friend ${x + 1}`)
        abort = true
      }
      if (!utils.isValidEmail(this.emails[x])) {
        utils.toast(this, 'Missing fields', `Invalid email address for friend ${x + 1}`)
        abort = true
      }
}

    // get rid of null NUM_SLOTS
    this.firstNames = this.firstNames.filter((s) => s != null && s.length > 0)
    this.lastNames = this.lastNames.filter((s) => s != null && s.length > 0)
    this.emails = this.emails.filter((s) => s != null && s.length > 0)

    if ((this.firstNames.length !== this.lastNames.length) ||
      (this.firstNames.length !== this.emails.length) ||
      (this.lastNames.length !== this.emails.length)) abort = true
    if (abort) return

    if (numFilled === 0 && (!this.storyTellerEmail || this.storyTellerEmail.length === 0)) return

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/users/invite';
      const response: any = await utils.makePostCall(url, { alsoInviteStoryTeller: this.alsoInviteStoryTeller, storyTellerFirstName: this.storyTellerFirstName, storyTellerLastName: this.storyTellerLastName, storyTellerEmail: this.storyTellerEmail, storyTellerPhone: this.fullPhoneNumber, firstNames: this.firstNames, lastNames: this.lastNames, emails: this.emails } );
      if (!response || !response.data) throw(new Error('InvitesFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user && response.data.users) {
        // success
        const numInvitesSent: number = response.data.users.length + (this.alsoInviteStoryTeller ? 1 : 0)
        if (this.alertOrToastWhenDone) {
          if (numInvitesSent > 1) utils.toast(this, 'Success', `Your ${numInvitesSent} invites have been sent out.`)
          else utils.toast(this, 'Success', `Your invite has been sent out.`)
        }

        this.$emit('close', true)

        // might as well update our user cache
        // TODO: consider adding all the invited users to cache - nah, not really worth it
        const me: StoryUser = new StoryUser(response.data.user)
        me.updateMeToCacheStoreAndLocalStorage()

        // clear out in case they do another
        this.clearFields()
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not invite')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    this.clearFields()
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }


}
